export default __webpack_public_path__ + "static/media/externalLinkGold.b04ffb4f.svg";